module.exports = __webpack_public_path__ + "img/fengcai.9a7eeb92.jpg";